export const DOCUMENT_TYPE_FINANCE_FRONTPAGE = 'finance-frontpage';
